var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11298_85593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 20,
    height: 20,
    transform: "rotate(90 20 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11298_85593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66658 5.83333L4.99992 2.5L8.33325 5.83333L7.12492 7L5.83325 5.70833L5.83325 14.1667L9.16658 14.1667L9.16658 15.8333L4.16658 15.8333L4.16658 5.70833L2.87492 7L1.66658 5.83333ZM10.8333 4.16667L15.8333 4.16667L15.8333 14.2917L17.1249 13L18.3333 14.1667L14.9999 17.5L11.6666 14.1667L12.8749 13L14.1666 14.2917L14.1666 5.83333L10.8333 5.83333L10.8333 4.16667Z",
    fill: "#0D0D0D",
    fillOpacity: 0.996078
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIconBlack);
export default __webpack_public_path__ + "static/media/swap-icon-black.39ff22e07966f123cfa0c1bdd8a7ad3c.svg";
export { ForwardRef as ReactComponent };